import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function Reseller() {
  const [status, setStatus]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm]       = useState({business_name:"",contact_email:"",phone:"",website:"",expected_clients:10});
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    API.get("/reseller/status")
      .then(r => setStatus(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const apply = async () => {
    if (!form.business_name || !form.phone) { setMsg("Business name and phone are required"); return; }
    setSubmitting(true);
    try {
      const res = await API.post("/reseller/apply", form);
      setMsg(res.data.message);
      setStatus({applied:true, status:"pending", ...form});
    } catch (e) {
      setMsg(e?.response?.data?.detail || "Failed to apply");
    }
    setSubmitting(false);
  };

  const s = { minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", padding:28 };
  if (loading) return <div style={s}><p style={{color:"#9ca3af",textAlign:"center",paddingTop:80}}>Loading...</p></div>;

  return (
    <div style={s}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet"/>
      <div style={{maxWidth:700, margin:"0 auto"}}>
        <button onClick={() => navigate("/dashboard")} style={{background:"transparent",color:"#9ca3af",border:"1px solid #ffffff22",borderRadius:10,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",marginBottom:24}}>← Dashboard</button>

        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:52,marginBottom:12}}>🏢</div>
          <h1 style={{fontFamily:"'Syne',sans-serif",fontSize:32,fontWeight:900,marginBottom:8}}>Become a Reseller</h1>
          <p style={{color:"#9ca3af",fontSize:16}}>Earn 30% commission on every client you bring to LeadBot Pro</p>
        </div>

        {/* Benefits */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:28}}>
          {[
            {icon:"💰",title:"30% Commission",desc:"Earn ₹300-₹1200 per client per month"},
            {icon:"♾️",title:"Unlimited Clients",desc:"No cap on how many clients you can bring"},
            {icon:"🏷️",title:"White Label Option",desc:"Offer under your own brand name"},
            {icon:"📊",title:"Reseller Dashboard",desc:"Track all your clients and earnings in one place"},
          ].map((b,i) => (
            <div key={i} style={{background:"#0d0d1f",border:"1px solid #ffffff0a",borderRadius:16,padding:20}}>
              <div style={{fontSize:28,marginBottom:8}}>{b.icon}</div>
              <div style={{fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:15,marginBottom:4}}>{b.title}</div>
              <div style={{color:"#9ca3af",fontSize:13}}>{b.desc}</div>
            </div>
          ))}
        </div>

        {status?.applied ? (
          <div style={{background:"#0d0d1f",border:"1px solid "+(status.status==="approved"?"#00d4aa44":"#f59e0b44"),borderRadius:20,padding:28,textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>{status.status==="approved"?"✅":"⏳"}</div>
            <h2 style={{fontFamily:"'Syne',sans-serif",fontSize:22,marginBottom:8}}>{status.status==="approved"?"Application Approved!":"Application Under Review"}</h2>
            <p style={{color:"#9ca3af",fontSize:15}}>
              {status.status==="approved" ? "You are an approved LeadBot Pro reseller. Share your referral link to start earning." : "We'll review your application within 24 hours and notify you by email."}
            </p>
            {status.status==="approved" && (
              <div style={{marginTop:20}}>
                <div style={{color:"#9ca3af",fontSize:13,marginBottom:8}}>Total Clients: <span style={{color:"#00d4aa",fontWeight:700}}>{status.total_clients||0}</span></div>
                <div style={{color:"#9ca3af",fontSize:13}}>Estimated Earnings: <span style={{color:"#00d4aa",fontWeight:700}}>₹{status.estimated_earnings||0}/month</span></div>
              </div>
            )}
          </div>
        ) : (
          <div style={{background:"#0d0d1f",border:"1px solid #ffffff0a",borderRadius:20,padding:28}}>
            <h3 style={{fontFamily:"'Syne',sans-serif",fontSize:18,marginBottom:20}}>Apply to Become a Reseller</h3>
            {[
              {label:"Business Name *",key:"business_name",placeholder:"Your company or freelance name"},
              {label:"Contact Email *",key:"contact_email",placeholder:"business@example.com"},
              {label:"Phone Number *",key:"phone",placeholder:"+91 98XXXXXXXX"},
              {label:"Website",key:"website",placeholder:"https://yourwebsite.com (optional)"},
            ].map((f,i) => (
              <div key={i} style={{marginBottom:16}}>
                <label style={{display:"block",color:"#9ca3af",fontSize:11,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>{f.label}</label>
                <input value={form[f.key]} onChange={e => setForm(p => ({...p,[f.key]:e.target.value}))} placeholder={f.placeholder}
                  style={{width:"100%",background:"#050510",border:"1px solid #ffffff22",borderRadius:10,padding:"12px 14px",color:"#fff",fontFamily:"'DM Sans',sans-serif",fontSize:14,boxSizing:"border-box",outline:"none"}}/>
              </div>
            ))}
            <div style={{marginBottom:20}}>
              <label style={{display:"block",color:"#9ca3af",fontSize:11,marginBottom:6,textTransform:"uppercase",letterSpacing:1}}>Expected Clients per Month</label>
              <select value={form.expected_clients} onChange={e => setForm(p => ({...p,expected_clients:Number(e.target.value)}))}
                style={{width:"100%",background:"#050510",border:"1px solid #ffffff22",borderRadius:10,padding:"12px 14px",color:"#fff",fontFamily:"'DM Sans',sans-serif",fontSize:14,boxSizing:"border-box",outline:"none"}}>
                {[5,10,20,50,100].map(n => <option key={n} value={n}>{n}+ clients</option>)}
              </select>
            </div>
            {msg && <div style={{background:"#00d4aa18",border:"1px solid #00d4aa44",borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13,color:"#00d4aa"}}>{msg}</div>}
            <button onClick={apply} disabled={submitting} style={{width:"100%",background:submitting?"#333":"linear-gradient(135deg,#00d4aa,#00b894)",color:submitting?"#666":"#050510",border:"none",borderRadius:12,padding:14,fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:15,cursor:submitting?"not-allowed":"pointer"}}>
              {submitting ? "Submitting..." : "Submit Application →"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
